import i18n from "~/i18n";
import { AvoltaAlarm, AvoltaAlarmKeyEnum, AvoltaAlarmCategoryEnum } from "./avolta-alarm.model";
import { AvoltaAlarmEnum } from "./avolta-alarm.model";
import { warningColor } from "~/variables";

export const AlarmValues: string[] = Object.keys(AvoltaAlarmKeyEnum);

export const AvoltaAlarmMapping: {[key in AvoltaAlarmKeyEnum]: AvoltaAlarmEnum } = {
    [AvoltaAlarmKeyEnum.CH4_concentration_alarm]: AvoltaAlarmEnum.CH4_concentration_alarm,
    [AvoltaAlarmKeyEnum.CH4_sensor_error_alarm]: AvoltaAlarmEnum.CH4_system_failure,
    [AvoltaAlarmKeyEnum.CH4_battery_alarm]: AvoltaAlarmEnum.CH4_battery_alarm,
    [AvoltaAlarmKeyEnum.CH4_temperature_alarm]: AvoltaAlarmEnum.CH4_system_failure,
    [AvoltaAlarmKeyEnum.CH4_ndir_fatal_alarm]: AvoltaAlarmEnum.CH4_system_failure,
    [AvoltaAlarmKeyEnum.CH4_ndir_intermittent_alarm]: AvoltaAlarmEnum.CH4_system_failure,
    [AvoltaAlarmKeyEnum.CH4_ndir_communication_alarm]: AvoltaAlarmEnum.CH4_system_failure,
    [AvoltaAlarmKeyEnum.CH4_env_out_of_range_alarm]: AvoltaAlarmEnum.CH4_system_failure,
    [AvoltaAlarmKeyEnum.CH4_internal_alarm]: AvoltaAlarmEnum.CH4_system_failure,
    [AvoltaAlarmKeyEnum.CH4_eol_alarm]: AvoltaAlarmEnum.CH4_eol_alarm
}

export const AvoltaAlarmCategoryMapping: {[key in AvoltaAlarmKeyEnum]: AvoltaAlarmCategoryEnum} = {
    [AvoltaAlarmKeyEnum.CH4_concentration_alarm]: AvoltaAlarmCategoryEnum.GAS_ALARM,
    [AvoltaAlarmKeyEnum.CH4_sensor_error_alarm]: AvoltaAlarmCategoryEnum.TROUBLE,
    [AvoltaAlarmKeyEnum.CH4_temperature_alarm]: AvoltaAlarmCategoryEnum.TROUBLE,
    [AvoltaAlarmKeyEnum.CH4_battery_alarm]: AvoltaAlarmCategoryEnum.TROUBLE,
    [AvoltaAlarmKeyEnum.CH4_ndir_fatal_alarm]: AvoltaAlarmCategoryEnum.TROUBLE,
    [AvoltaAlarmKeyEnum.CH4_ndir_intermittent_alarm]: AvoltaAlarmCategoryEnum.TROUBLE,
    [AvoltaAlarmKeyEnum.CH4_ndir_communication_alarm]: AvoltaAlarmCategoryEnum.TROUBLE,
    [AvoltaAlarmKeyEnum.CH4_env_out_of_range_alarm]: AvoltaAlarmCategoryEnum.TROUBLE,
    [AvoltaAlarmKeyEnum.CH4_internal_alarm]: AvoltaAlarmCategoryEnum.TROUBLE,
    [AvoltaAlarmKeyEnum.CH4_eol_alarm]: AvoltaAlarmCategoryEnum.TROUBLE
}

export const AvoltaAlarmConfiguration: { [key in AvoltaAlarmEnum]: AvoltaAlarm } = {
    [AvoltaAlarmEnum.CH4_concentration_alarm]: {
        name: AvoltaAlarmEnum.CH4_concentration_alarm,
        label: i18n.global.t('avolta.alarm.ch4.label'),
        icon: 'elichens-avolta elichens-ch4-alert',
        short: i18n.global.t('avolta.alarm.ch4.short'),
        color: '#CA3930'
    },
    [AvoltaAlarmEnum.CH4_system_failure]: {
        name: AvoltaAlarmEnum.CH4_system_failure,
        label: i18n.global.t('avolta.alarm.system_failure.label'),
        icon: 'mdi mdi-smoke-detector-alert',
        short: i18n.global.t('avolta.alarm.system_failure.short'),
        color: warningColor,
    },
    [AvoltaAlarmEnum.CH4_battery_alarm]: {
        name: AvoltaAlarmEnum.CH4_battery_alarm,
        label: i18n.global.t('avolta.alarm.battery.label'),
        icon: 'mdi mdi-battery-alert-variant-outline',
        short: i18n.global.t('avolta.alarm.battery.short'),
        color: '#3598DB'
    },
    [AvoltaAlarmEnum.offline]: {
        name: AvoltaAlarmEnum.offline,
        label: i18n.global.t('avolta.alarm.offline.label'),
        icon: 'mdi mdi-signal-off',
        short: i18n.global.t('avolta.alarm.offline.short'),
        color: '#9B58B5'
    },
    [AvoltaAlarmEnum.CH4_eol_alarm]: {
        name: AvoltaAlarmEnum.CH4_eol_alarm,
        label: i18n.global.t('avolta.alarm.end_of_life.label'),
        icon: 'mdi mdi-heart-pulse',
        short: i18n.global.t('avolta.alarm.end_of_life.short'),
        color: '#0f0f0f'
    }
};